// The swap of a regenerated markup around a kept element (R1620).
//
// The tab body regenerates its markup on the overlay's 4 Hz guard, and a
// regenerate replaces every element of the body. A control that a finger
// drags (the scrubber of the season timelapse) must not be replaced under
// the drag, because the browser ends a drag on an element that leaves the
// document. So the markup carries a mark where the control stands, and
// this swap writes the markup before the mark and after it AROUND the kept
// element, which never leaves the document.
//
// The mark must stand at the top level of the markup, between two whole
// elements: the swap cuts the string there.

/**
 * Writes `html` into `host`. When `html` carries `mark` and `island` is
 * given, the island stands at the mark and stays in the document if it
 * already stood in `host`. Without either, this is `innerHTML`.
 */
export function swapAroundIsland(
  host: HTMLElement, html: string, island: HTMLElement | null, mark: string,
): void {
  const at = island === null ? -1 : html.indexOf(mark);
  if (island === null || at < 0) {
    host.innerHTML = html;
    return;
  }
  if (island.parentNode === host) {
    for (const n of Array.from(host.childNodes)) if (n !== island) n.remove();
  } else {
    host.replaceChildren(island);
  }
  island.insertAdjacentHTML('beforebegin', html.slice(0, at));
  island.insertAdjacentHTML('afterend', html.slice(at + mark.length));
}
